<template>
	<div>
		<h1>PayChangu Debit/Credit Card</h1>

		<BackButton
			text="Back to Deposit Menu"
			@click="backmenu"
		/>

		<p>
			You can deposit money on your wallet using card payment.<br>
			<img src="/icons/paychangu.png" alt="Paychangu Logo" style="height: 20px; vertical-align: middle; margin-right: 5px;">
			Debit/Credit Card Deposit.<br>
			Hello user: <a>{{ username }}</a>
		</p>

		<div class="contenedor">
			<p>Complete your details and click Pay Now.</p>

			<div class="field-grid">
				<input v-model.trim="form.firstName" type="text" placeholder="First name">
				<input v-model.trim="form.lastName" type="text" placeholder="Last name">
				<input v-model.trim="form.email" type="email" placeholder="Email">
			</div>

			<div class="amount-section">
				<span>Amount</span>
				<div class="amount">
					<button class="button">MWK</button>
					<input
						v-model.number="form.amount"
						type="number"
						min="1"
						step="1"
						placeholder="Enter amount"
					>
				</div>
			</div>

			<div id="wrapper"></div>

			<button
				class="deposit"
				type="button"
				:disabled="isLoading || !isPaychanguReady"
				@click="makePayment"
			>
				<span v-if="isLoading">Opening Checkout...</span>
				<span v-else>Pay Now</span>
			</button>
		</div>

		<ResponseMessage
			:message="responseMessage"
			:type="responseType"
		/>

		<div class="finaltext">
			<p>
				After successful payment, PayChangu will redirect to your callback and return URL.<br>
				<a>Note</a>: Make sure pop-up blockers are disabled.
			</p>
		</div>
	</div>
</template>

<script>
import paychanguService from '@/scripts/ApiServicePaychangu.js';
import BackButton from '@/components/BackButton.vue';
import ResponseMessage from '@/components/ResponseMessage.vue';

export default {
	components: {
		BackButton,
		ResponseMessage
	},
	data() {
		return {
			username: this.$route.query.username || 'Unknown User',
			isLoading: false,
			isPaychanguReady: false,
			responseMessage: '',
			responseType: 'info',
			form: {
				amount: '',
				email: '',
				firstName: '',
				lastName: ''
			},
			currency: 'MWK',
            reference_wsb: '',
			publicKey: '',//process.env.VUE_APP_PAYCHANGU_PUBLIC_KEY || 'pub-test-HYSBQpa5K91mmXMHrjhkmC6mAjObPJ2u',
			callbackUrl: window.location.origin + window.location.pathname + '#/PaychanguBankTransferCallback',
			returnUrl: window.location.origin + window.location.pathname + '#/PaychanguBankTransferCallback'
		};
	},
	methods: {
		backmenu() {
			this.$router.push({
				name: 'DepositWebsiteMalawi',
				query: { username: this.$route.query.username }
			});
		},
		sendHeight() {
			const height = document.body.scrollHeight;
			window.parent.postMessage({ iframeHeight: height }, '*');
		},
		async loadPaychanguScript() {
			if (window.PaychanguCheckout) {
				this.isPaychanguReady = true;
				return;
			}

			const existingScript = document.querySelector('script[src="https://in.paychangu.com/js/popup.js"]');
			if (existingScript) {
				existingScript.addEventListener('load', () => {
					this.isPaychanguReady = !!window.PaychanguCheckout;
				});
				this.isPaychanguReady = !!window.PaychanguCheckout;
				return;
			}

			await new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.src = 'https://in.paychangu.com/js/popup.js';
				script.async = true;
				script.onload = resolve;
				script.onerror = reject;
				document.body.appendChild(script);
			});

			this.isPaychanguReady = !!window.PaychanguCheckout;
		},
		buildTxRef() {
			const random = Math.floor((Math.random() * 1000000000) + 1);
			return `wsb-${Date.now()}-${random}`;
		},
		async makePayment() {
			if (!this.form.amount || this.form.amount < 50) {
				this.responseMessage = 'Amount must be at least 50 MWK.';
				this.responseType = 'error';
				return;
			}

			if (!this.form.email || !this.form.firstName || !this.form.lastName) {
				this.responseMessage = 'Email, first name, and last name are required.';
				this.responseType = 'error';
				return;
			}

			if (!window.PaychanguCheckout) {
				this.responseMessage = 'PayChangu script is not loaded yet. Please try again.';
				this.responseType = 'error';
				return;
			}

			this.isLoading = true;
			this.responseMessage = '';

             const response = await paychanguService.createDeposit({ appkey: "" , username: this.$route.query.username , amount: this.form.amount });
                
                if (response.success) {
                //console.log("litebox response", response.data.Lite_Merchant_ApplicationID);
                
                // Actualizar `localFormData`, ya que `props.formData` no se puede modificar directamente
                this.publicKey = response.data.public_key;
                this.reference = response.data.reference_wsb;
                if (!this.publicKey) {
                    this.responseMessage = 'Missing PayChangu public key.';
                    this.responseType = 'error';
                    return;
                }
                this.redirigirPorPost();
                
                } else {
                console.error("Error en la respuesta del backend");
                } 
		},
		redirigirPorPost() {
        try {
			//alert(`${this.callbackUrl}?username=${encodeURIComponent(this.username)}&reference=${encodeURIComponent(this.reference)}`);
				window.PaychanguCheckout({
					public_key: this.publicKey,
					tx_ref: this.reference,
					
					amount: Number(this.form.amount),
					currency: this.currency,
					callback_url: `${process.env.VUE_APP_API_URL_PAYCHANGU_IFRAME_CALLBACK}`,//`${this.callbackUrl}?username=${encodeURIComponent(this.username)}&reference=${encodeURIComponent(this.reference)}`,
					return_url:  `${process.env.VUE_APP_API_URL_PAYCHANGU_IFRAME_CALLBACK}`,
					customer: {
						email: this.form.email,
						first_name: this.form.firstName,
						last_name: this.form.lastName
					},
					customization: {
						title: 'WSB Deposit',
						description: 'Wallet deposit with PayChangu Inline Popup'
					},
					meta: {
						username: this.username,
						source: 'wsb-financial-inline'
					}
				});

				this.responseMessage = 'Checkout opened. Complete the payment in the popup window.';
				this.responseType = 'info';
			} catch (error) {
				this.responseMessage = `Unable to start checkout: ${error.message}`;
				this.responseType = 'error';
			} finally {
				this.isLoading = false;
			}
		}
	},
	async mounted() {
		try {
			await this.loadPaychanguScript();
			if (!this.isPaychanguReady) {
				this.responseMessage = 'PayChangu checkout script did not initialize correctly.';
				this.responseType = 'error';
			}
		} catch (error) {
			this.responseMessage = 'Failed to load PayChangu checkout script.';
			this.responseType = 'error';
		}

		this.sendHeight();
		window.addEventListener('resize', this.sendHeight);
	},
	updated() {
		this.$nextTick(() => {
			this.sendHeight();
		});
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.sendHeight);
	}
};
</script>

<style scoped>
h1 {
	color: #000;
	text-align: center;
	font-weight: 800;
	padding: 15px;
}

p {
	color: #555;
	text-align: center;
}

.contenedor {
	padding: 30px 10px;
	display: block;
	background-color: #e7e7e7;
	align-content: center;
	justify-items: center;
}

.amount-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 30%;
	min-width: 275px;
	margin: 0 auto 12px;
}

.amount {
	width: 100%;
	display: flex;
	justify-content: center;
}

.field-grid {
	width: 30%;
	min-width: 275px;
	display: grid;
	gap: 10px;
	margin-bottom: 14px;
}

input[type="number"],
input[type="email"],
input[type="text"] {
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 0;
	font-size: 16px;
	width: 100%;
	box-sizing: border-box;
}

.button {
	padding: 10px 20px;
	background-color: #dedede;
	color: #000;
	border: 1px solid #ccc;
	border-radius: 0;
	font-size: 16px;
}

.deposit {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30%;
	min-width: 275px;
	margin-top: 10px;
	padding: 10px 20px;
	cursor: pointer;
	color: black;
	background-color: #cddc39;
	border: 2px solid #cddc39;
	border-radius: 6px;
	transition: background-color 0.3s ease;
}

.deposit:hover:not(:disabled) {
	border: 2px solid #0e9e29;
	background-color: #b7dc39;
}

.deposit:disabled {
	cursor: not-allowed;
	background-color: #ccc;
	border-color: #ccc;
}

.finaltext {
	padding-left: 10px;
	padding-right: 10px;
	display: block;
}
</style>
